import { Link, useLoaderData } from 'react-router-dom';
import { Container } from '@dma/ui';
import type { ArticleDto } from '../application/dto/ArticleDto';
import { useDocumentHead } from '../../../app/seo/useDocumentHead';
import { renderTextWithLinks } from '../../../app/content/renderTextWithLinks';
import './ArticleDetailPage.css';

export interface ArticleDetailLoaderData {
  heading: string;
  basePath: string;
  article: ArticleDto;
}

function formatDate(iso: string | null): string {
  if (!iso) return '';
  return new Date(iso).toLocaleDateString('fa-IR');
}

export function ArticleDetailPage() {
  const { heading, basePath, article } = useLoaderData() as ArticleDetailLoaderData;
  useDocumentHead({
    title: article.title,
    description: article.summary,
    ogImage: article.coverImage ?? undefined
  });

  return (
    <Container>
      <article className="dma-article-detail">
        <Link to={basePath} className="dma-article-detail__back">
          ← بازگشت به {heading}
        </Link>

        {article.coverImage ? (
          <img className="dma-article-detail__image" src={article.coverImage} alt={article.title} loading="lazy" />
        ) : null}

        {article.publishedAt ? (
          <time className="dma-article-detail__date" dateTime={article.publishedAt}>
            {formatDate(article.publishedAt)}
          </time>
        ) : null}

        <h1>{article.title}</h1>
        {article.summary ? <p className="dma-article-detail__summary">{article.summary}</p> : null}

        <div className="dma-article-detail__body">
          {article.body
            .split('\n')
            .filter((paragraph) => paragraph.trim().length > 0)
            .map((paragraph, index) => (
              <p key={index}>{renderTextWithLinks(paragraph, `article-body-${index}`)}</p>
            ))}
        </div>
      </article>
    </Container>
  );
}
